import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { ISupportState } from './support.reducer';
import * as fromReducer from './support.reducer';

const getSupportState = createFeatureSelector<ISupportState>('support');

export const getFaqs = createSelector(getSupportState, fromReducer.getFaqs);
export const getFaqsActionState = createSelector(getSupportState, fromReducer.getFaqsActionState);
export const getOverviewFaqs = createSelector(getSupportState, fromReducer.getOverviewFaqs);
export const getOverviewFaqsActionState = createSelector(
  getSupportState,
  fromReducer.getOverviewFaqsActionState
);
